module.exports = __webpack_public_path__ + "static/media/anyone.4d1fe337.svg";